import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private requestsInProgress = 0;
  isLoading = new BehaviorSubject<boolean>(false);

  show() {
    this.requestsInProgress++;
    if (this.requestsInProgress === 1) {
      this.isLoading.next(true);
    }
  }

  hide() {
    this.requestsInProgress--;
    if (this.requestsInProgress === 0) {
      this.isLoading.next(false);
    }
  }
}


